"use client";

import dynamic from "next/dynamic";
import { ComponentType, FC, useState } from "react";
import Conditional from "@repo/shared-ui/Conditional";
import { IStockFundamentalsContent } from "../../interfaces/StockFundamentals.interface";
import { decodeHtmlEntities } from "@repo/shared-utils/common-utils";
import {
  handleCloseBtnDL,
  handleInfoIconDL,
} from "./StockFundamentalsFunction";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";

// load modal only if clicked
const BFLModal: ComponentType<any> = dynamic(
  () => {
    return import("@repo/shared-ui/BFLModal") as any;
  },
  { ssr: false },
);
interface StockFundamentalModalProps {
  content: IStockFundamentalsContent;
}

const StockFundamentalModal: FC<StockFundamentalModalProps> = ({ content }) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
    handleInfoIconDL(loginStatus, content?.popupTitleText ?? "");
  };

  const handleClose = () => {
    setIsModalOpen(false);
    handleCloseBtnDL(
      loginStatus,
      content?.popupTitleText ?? "",
      content?.popUpCTAText ?? "",
      false,
    );
  };

  return (
    <>
      <button
        className={`text-link-primary cursor-pointer text-base`}
        onClick={handleOpen}
      >
        <i className="icomoon before:content-['\e907']" />
      </button>

      <Conditional if={isModalOpen}>
        <BFLModal
          isOpen={isModalOpen}
          onClose={handleClose}
          contentClassName="text-link-secondary"
          title={content?.popupTitleText ?? ""}
          description={content?.popupSubtitleText ?? ""}
          buttonText={content?.popUpCTAText ?? ""}
          modalData={content?.popUpDescription ?? ""}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: decodeHtmlEntities(content?.popUpDescription ?? ""),
            }}
            className="max-h-[455px] md:max-h-[306px]"
          ></div>
        </BFLModal>
      </Conditional>
    </>
  );
};
export default StockFundamentalModal;
